export interface IDisplayObjectConfig {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    scaleX?: number;
    scaleY?: number;
    flipH?: boolean;
    flipV?: boolean;
    anchor?: {x: number; y: number;};
    containerAnchor?: {x: number; y: number;};
    name?: string;
    mask?: number[];
    visible?: boolean;
    type?: string;
}